import ApiService from '../../services/ApiService.js';

export const namespaced = true;

export const state = {
	courses: []
};

export const mutations = {
};

export const actions = {
	// eslint-disable-next-line
	add({commit}, data) {
		return ApiService.addCourse(data);
	},
	// eslint-disable-next-line
	edit({commit}, data) {
		return ApiService.editCourse(data);
	},
	// eslint-disable-next-line
	addTee({commit}, data) {
		return ApiService.addCourseTee(data);
	},
	editTee({commit}, data) {
		return ApiService.editCourseTee(data);
	},
	// eslint-disable-next-line
	getCourse({commit}, uuid) {
		return ApiService.getCourse(uuid);
	},
};

export const getters = {};
